<div class="checkout-container">
  <umkt-loading
    *ngIf="isLoading || (cartLoading$ | async) || (availableOffersLoading$ | async)"
    [isLoading]="true"
    [size]="'md'"
    [mode]="'overlay'"
    [showText]="true"
    [text]="(isLoading ? 'pages.checkout.loading' : 'pages.checkout.loadingDraft') | i18n"
  >
  </umkt-loading>

  <div class="checkout-steps">
    <section class="breadcrumb-section">
      <a routerLink="/" class="breadcrumb-section__link">
        <umkt-icon [icon]="{ name: 'chevron_left', type: 'material-icons' }" size="sm" color="#005c66"></umkt-icon>
        {{ 'pages.checkout.breadcrumb.backHome' | i18n }}
      </a>
      <div *ngIf="(cartCount$ | async) !== 0" class="breadcrumb-section__content">
        <p>{{ 'pages.checkout.breadcrumb.safe' | i18n }}</p>
        <umkt-icon [icon]="{ name: 'cadeado', type: 'mondrian-icons' }" size="sm"></umkt-icon>
      </div>
    </section>

    <section class="checkout-header" *ngIf="(cartCount$ | async) !== 0">
      <h1>{{ 'pages.checkout.header' | i18n }}</h1>
    </section>

    <!-- Tela de carrinho vazio -->
    <ng-container *ngIf="(cartCount$ | async) === 0">
      <div class="cart-empty-checkout" aria-label="Carrinho vazio">
        <div class="cart-empty__content">
          <div class="cart-empty__image">
            <img src="assets/images/cart.png" alt="Ilustração de carrinho vazio" />
          </div>
          <div class="cart-empty__message">
            <p class="cart-empty__title">{{ 'pages.checkout.empty.title' | i18n }}</p>
            <p class="cart-empty__description">
              {{ 'pages.checkout.empty.description' | i18n }}
            </p>
          </div>
        </div>
        <div class="cart-empty__products">
          <p class="cart-empty__products-header">{{ 'pages.checkout.empty.productsHeader' | i18n }}</p>
          <umkt-cart-product-list
            [products]="(mockCartProducts$ | async) ?? []"
            [isCartEmpty]="true"
            [useCategoryLayoutWhenEmpty]="true"
            (removePlan)="onRemovePlan($event)"
            (changeQty)="onChangeQty($event)"
          >
          </umkt-cart-product-list>
        </div>
      </div>
    </ng-container>

    <!-- Stepper Component -->
    <div class="stepper-container">
      <umkt-stepper *ngIf="(cartCount$ | async) !== 0" [steps]="visibleSteps" [currentStepIndex]="currentStepIndex">
      </umkt-stepper>
    </div>

    <section class="checkout-content" *ngIf="(cartCount$ | async) !== 0">
      <!-- Step 1: Company Card -->
      <ng-container *ngIf="shouldShowCompanyCard()">
        <umkt-company-card
          [canGoToNextStep]="canGoToNextStep()"
          [isCardLoading]="isLoading"
          [enableMindCustomerFields]="hasMindItemsInCart"
          [mindCustomer]="savedMindCustomer"
          (mindCustomerChange)="onMindCustomerChange($event)"
          (nextStep)="onNextStep()"
          [isEditing]="true"
        ></umkt-company-card>
      </ng-container>

      <!-- Step 2: Installation Address Card -->
      <ng-container *ngIf="shouldShowInstallationAddressCard()">
        <umkt-installation-address-card
          [canGoToNextStep]="canGoToNextStep()"
          [isCardLoading]="isLoading"
          [isLastStep]="false"
          [fetchMindHps]="fetchMindInstallationHps"
          (nextStep)="onNextStep()"
          (previousStep)="onPreviousStep()"
          (addressDetailsSubmit)="onAddressDetailsSubmit($event)"
          [isEditing]="true"
        ></umkt-installation-address-card>
      </ng-container>

      <!-- Step 3: Schedule Card  -->
      <ng-container *ngIf="shouldShowScheduleCard()">
        <umkt-schedule-picker-card
          [slotsResponse]="scheduleSlotsResponse"
          [disableAutoFetch]="true"
          [canGoToNextStep]="canGoToNextStep()"
          [isCardLoading]="isLoading"
          (nextStep)="onNextStep()"
          (previousStep)="onPreviousStep()"
          (scheduleSubmit)="onScheduleSubmit($event)"
          [isEditing]="true"
        ></umkt-schedule-picker-card>
      </ng-container>

      <!-- Step 4: Payment -->
      <ng-container *ngIf="shouldShowPaymentCard()">
        <umkt-payment-method-card
          *ngIf="showPaymentMethodCard && !isFixaPaymentFlow && (isMobileLogin || hasMceInvoiceUnavailableItems)"
          [canGoToNextStep]="!showPaymentInvoiceCard"
          [initiallyOpen]="true"
          [disabled]="false"
          [invoicePaymentType]="invoicePaymentType"
          [showInvoiceUnavailableWarning]="hasMceInvoiceUnavailableItems"
          [invoiceUnavailableProducts]="mceInvoiceUnavailableProductLabels"
          [disableInvoiceOption]="hasMceInvoiceUnavailableItems"
          (invoicePaymentTypeChange)="onInvoicePaymentTypeChange($event)"
          (nextStep)="onShowPaymentInvoice()"
          (previousStep)="onPreviousStep()"
          (editingStateChange)="onPaymentMethodCardEditingStateChange($event)"
        ></umkt-payment-method-card>
        <umkt-payment-invoice-card
          [canGoToPreviousStep]="showPaymentMethodCard"
          [canGoToNextStep]="canGoToNextStep()"
          [initiallyOpen]="!showPaymentMethodCard || (showPaymentInvoiceCard && !isPaymentMethodCardEditing)"
          [disabled]="showPaymentMethodCard && (!showPaymentInvoiceCard || isPaymentMethodCardEditing)"
          [invoicePaymentType]="invoicePaymentType"
          [initialSelectedPaymentMethod]="selectedPaymentMethod"
          [initialSelectedCardId]="selectedCardId"
          [initialSellerCode]="savedSellerCode"
          [initialSellerData]="savedSellerData"
          (previousStep)="onPreviousStep()"
          (nextStep)="onNextStep()"
          (paymentMethodChange)="onPaymentMethodChange($event)"
          (tokenCardSelected)="onTokenCardSelected($event)"
        ></umkt-payment-invoice-card>
      </ng-container>

      <!-- Step 3: Product Configuration -->
      <ng-container *ngIf="shouldShowProductConfig()">
        <umkt-product-config-card
          [isLastStep]="false"
          (previousStep)="onPreviousStep()"
          (nextStep)="onNextStep()"
          (validateOrderRequest)="onProductConfigValidateOrderRequest($event)"
        ></umkt-product-config-card>
      </ng-container>

      <!-- Step 4: Phone Linking (Conditional) -->
      <ng-container *ngIf="shouldShowPhoneLinking()">
        <umkt-product-link-card
          [canGoToPreviousStep]="canGoToPreviousStep() || mceLinkingFromReview"
          [canGoToNextStep]="canGoToNextStep() || mceLinkingFromReview"
          [isEditing]="true"
          (previousStep)="onProductLinkPreviousStep()"
          (nextStep)="onProductLinkNextStep()"
        ></umkt-product-link-card>
      </ng-container>

      <!-- Step 5: Completed - Show all cards open in view mode -->
      <ng-container *ngIf="shouldShowCompleted()">
        <!-- Company Card -->
        <umkt-company-card
          [canGoToNextStep]="false"
          [isCardLoading]="isLoading"
          [isEditing]="false"
          [enableMindCustomerFields]="hasMindItemsInCart"
          [mindCustomer]="savedMindCustomer"
        ></umkt-company-card>

        <!-- Installation Address Card (apenas quando há itens MIND no carrinho) -->
        <umkt-installation-address-card
          *ngIf="hasMindItemsInCart"
          [canGoToNextStep]="false"
          [isCardLoading]="isLoading"
          [isEditing]="isInstallationAddressCardEditing"
          [isLastStep]="true"
          [fetchMindHps]="fetchMindInstallationHps"
          [savedAddressDetails]="savedAddressDetails"
          (editingStateChange)="onInstallationAddressCardEditingStateChange($event)"
          (addressDetailsSubmit)="onAddressDetailsSubmit($event)"
        ></umkt-installation-address-card>

        <!-- Schedule Card (apenas quando há itens MIND no carrinho) -->
        <umkt-schedule-picker-card
          *ngIf="hasMindItemsInCart"
          [slotsResponse]="scheduleSlotsResponse"
          [disableAutoFetch]="true"
          [canGoToNextStep]="false"
          [isCardLoading]="isLoading"
          [isEditing]="isScheduleCardEditing"
          [selections]="savedScheduleSelections"
          [useCancelInsteadOfBack]="true"
          (editingStateChange)="onScheduleCardEditingStateChange($event)"
          (previousStep)="onScheduleCardEditingStateChange(false)"
          (scheduleSubmit)="onScheduleSubmit($event)"
        ></umkt-schedule-picker-card>

        <!-- Payment Cards -->
        <umkt-payment-method-card
          *ngIf="showPaymentMethodCard && (isMobileLogin || hasMceInvoiceUnavailableItems)"
          [isEditing]="false"
          [canGoToNextStep]="false"
          [isLastStep]="true"
          [invoicePaymentType]="invoicePaymentType"
          [showInvoiceUnavailableWarning]="hasMceInvoiceUnavailableItems"
          [invoiceUnavailableProducts]="mceInvoiceUnavailableProductLabels"
          [disableInvoiceOption]="hasMceInvoiceUnavailableItems"
          (invoicePaymentTypeChange)="onInvoicePaymentTypeChange($event)"
          (editingStateChange)="onPaymentMethodCardEditingStateChange($event)"
        ></umkt-payment-method-card>
        <umkt-payment-invoice-card
          [canGoToPreviousStep]="false"
          [canGoToNextStep]="false"
          [isEditing]="isPaymentInvoiceCardEditing"
          [invoicePaymentType]="invoicePaymentType"
          [isLastStep]="true"
          [initiallyOpen]="true"
          [initialSelectedPaymentMethod]="selectedPaymentMethod"
          [initialSelectedCardId]="selectedCardId"
          [initialSellerCode]="savedSellerCode"
          [initialSellerData]="savedSellerData"
          (editingStateChange)="onPaymentInvoiceCardEditingStateChange($event)"
          (paymentMethodChange)="onPaymentMethodChange($event)"
          (tokenCardSelected)="onTokenCardSelected($event)"
        ></umkt-payment-invoice-card>

        <!-- Product Config Card -->
        <umkt-product-config-card
          *ngIf="showProductConfigCard"
          [isEditing]="false"
          [isLastStep]="true"
          (validateOrderRequest)="onProductConfigValidateOrderRequest($event)"
        ></umkt-product-config-card>

        <!-- Phone Linking Card -->
        <umkt-product-link-card
          *ngIf="isMinhaClaroSelected"
          [canGoToPreviousStep]="false"
          [canGoToNextStep]="false"
          [isEditing]="false"
          [isLastStep]="true"
          [navigateToLinkingStepOnEdit]="isMceExternalFlow"
          [showAutoLinkWarning]="mceShowAutoLinkWarning"
          (navigateToLinkingStep)="onMceNavigateToLinkingStep()"
          (editingStateChange)="onProductLinkCardEditingStateChange($event)"
        ></umkt-product-link-card>
      </ng-container>
    </section>
  </div>

  <div class="checkout-summary" *ngIf="(cartCount$ | async) !== 0">
    <umkt-order-summary-card
      [validatedSvaOrderPayload]="validatedSvaOrderPayload"
      [maxQuantityByPlanId]="mceQuantityLimitsByPlanId"
      (removeProduct)="onOrderSummaryItemRemoved()"
      (removePlan)="onOrderSummaryItemRemoved()"
      (quantityDecreased)="onOrderSummaryItemRemoved()"
    ></umkt-order-summary-card>

    <ng-container *ngIf="shouldShowCompleted()">
      <div class="terms-checkbox">
        <input
          type="checkbox"
          id="terms-checkbox"
          required
          [checked]="termsAccepted"
          (change)="onTermsAcceptedChange($event)"
        />
        <label for="terms-checkbox" [innerHTML]="'pages.checkout.summary.terms' | i18n: { link: termsAndConditionsUrl }">
        </label>
      </div>

      <div class="terms-checkbox" *ngIf="microsoftTermsUrl">
        <input
          type="checkbox"
          id="microsoft-terms-checkbox"
          required
          [checked]="microsoftTermsAccepted"
          (change)="onMicrosoftTermsAcceptedChange($event)"
        />
        <label for="microsoft-terms-checkbox" [innerHTML]="'pages.checkout.summary.microsoftTerms' | i18n: { link: microsoftTermsUrl }">
        </label>
      </div>

      <ustore-button
        [text]="(isLoading ? 'pages.checkout.summary.buttonLoading' : 'pages.checkout.summary.button') | i18n"
        [format]="'filled'"
        [backgroundColor]="'var(--color-yellow-500-to-yellow)'"
        [textColor]="'#000000'"
        [size]="'medium'"
        [rounded]="'default'"
        [full]="true"
        (click)="onSubmit()"
        [disabled]="isSubmitButtonDisabled"
      >
      </ustore-button>
    </ng-container>
  </div>
</div>